import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {BoardButton} from '@components/common/base/buttons'

const TwShowMoreButton = tw(BoardButton)`
  !w-full
  ${p => (p.noBorder ? 'shadow-xs' : '')}
`

export interface ShowMoreButtonProps {
  count: number
  onClick: () => void
  className?: string
  noBorder?: boolean
}

export const ShowMoreButton = ({
  count,
  onClick,
  className,
  noBorder
}: ShowMoreButtonProps) => (
  <TwShowMoreButton
    onClick={onClick}
    className={className}
    title={Lang.msg.showMoreTasks(count)}
    noBorder={noBorder}
  />
)
